// DEPENDENCIES
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
// COMPONENTS
import { Link, useParams } from 'react-router-dom';
import { Spinner, Modal, Button } from 'react-bootstrap';
import SVG from 'react-inlinesvg';
import { NavLink } from 'react-router-dom';
import Select from 'react-select';
// CUSTOM COMPONENTS
import * as alert from '../../../../redux/alertSnackBarRedux';
import * as confirmModal from '../../../../redux/confirmModalRedux';
// SERVICES AND HELPERS
import { toAbsoluteUrl } from '../../../../_metronic/_helpers';
import * as helper from '../../../../helpers/helper';
import constants from '../../../../constants/constants';

const JobManageCard = (props) => {
  const { history, showAlert, auth, showConfirmModal, hideConfirmModal, setProcessing, jobInfo, jobId } = props;

  return (
    <>
      <div className='aes-job-manage-sidebar flex-row-auto offcanvas-mobile w-250px w-xxl-350px' id='kt_profile_aside'>
        <div className='card card-custom card-stretch'>
          <div className='card-body pt-4'>
            <div className='d-flex align-items-center'>
              <div>
                <a href='#' className='font-weight-boldest font-size-h3 text-dark-75 text-hover-primary'>
                  Job #{jobInfo.projectNumber}
                </a>
              </div>
            </div>

            <div className='py-9'>
              <div className='d-flex align-items-center justify-content-between mb-2'>
                <span className='font-weight-bold mr-2'>Project Name</span>
                <span className='text-muted text-hover-primary'>{jobInfo.projectName}</span>
              </div>
              <div className='d-flex align-items-center justify-content-between mb-2'>
                <span className='font-weight-bold mr-2'>Awarded Datetime:</span>
                <span className='text-muted text-hover-primary'>{jobInfo.awardedDateTime}</span>
              </div>

              <div className='mt-5'>
                <Link
                  to={'/services/manage-proposal/general-information/' + jobInfo.proposalId}
                  className='btn btn-sm btn-success font-weight-bold mr-2 py-2 px-3 px-xxl-5 my-1'
                >
                  View Proposal
                </Link>
                <a
                  className='btn btn-sm btn-info font-weight-bold mr-2 py-2 px-3 px-xxl-5 my-1'
                  href={constants.API_URL + 'api/Proposal/GetProposalPdf?proposalId=' + jobInfo.proposalId + '&token=' + auth.authToken}
                  target='_blank'
                  rel='noreferrer'
                >
                  View Proposal PDF
                </a>
              </div>
            </div>
            <div className='navi navi-bold navi-hover navi-active navi-link-rounded'>
              <div className='navi-item mb-2'>
                <NavLink to={'/services/manage-job/general-information/' + jobId} className='navi-link py-4' activeClassName='active'>
                  <span className='navi-icon mr-2'>
                    <span className='svg-icon'>
                      <SVG src={toAbsoluteUrl('/media/svg/icons/Design/Layers.svg')}></SVG>{' '}
                    </span>
                  </span>
                  <span className='navi-text font-size-lg'>General Information</span>
                </NavLink>
              </div>
              <div className='navi navi-bold navi-hover navi-active navi-link-rounded'>
                <div className='navi-item mb-2'>
                  <NavLink to={'/services/manage-job/team/' + jobId} className='navi-link py-4' activeClassName='active'>
                    <span className='navi-icon mr-2'>
                      <span className='svg-icon'>
                        <SVG src={toAbsoluteUrl('/media/svg/icons/Communication/Group.svg')}></SVG>{' '}
                      </span>
                    </span>
                    <span className='navi-text font-size-lg'>Credential & Team</span>
                  </NavLink>
                </div>
              </div>
              <div className='navi navi-bold navi-hover navi-active navi-link-rounded'>
                <div className='navi-item mb-2'>
                  <NavLink to={'/services/manage-job/schedule/' + jobId} className='navi-link py-4' activeClassName='active'>
                    <span className='navi-icon mr-2'>
                      <span className='svg-icon'>
                        <SVG src={toAbsoluteUrl('/media/svg/icons/Layout/Layout-grid.svg')}></SVG>{' '}
                      </span>
                    </span>
                    <span className='navi-text font-size-lg'>Schedule</span>
                  </NavLink>
                </div>
              </div>
              <div className='navi navi-bold navi-hover navi-active navi-link-rounded'>
                <div className='navi-item mb-2'>
                  <NavLink to={'/services/manage-job/forms/' + jobId} className='navi-link py-4' activeClassName='active'>
                    <span className='navi-icon mr-2'>
                      <span className='svg-icon'>
                        <SVG src={toAbsoluteUrl('/media/svg/icons/Files/File.svg')}></SVG>{' '}
                      </span>
                    </span>
                    <span className='navi-text font-size-lg'>Forms</span>
                  </NavLink>
                </div>
              </div>
              <div className='navi navi-bold navi-hover navi-active navi-link-rounded'>
                <div className='navi-item mb-2'>
                  <NavLink to={'/services/manage-job/timesheet/' + jobId} className='navi-link py-4' activeClassName='active'>
                    <span className='navi-icon mr-2'>
                      <span className='svg-icon'>
                        <SVG src={toAbsoluteUrl('/media/svg/icons/Home/Timer.svg')}></SVG>{' '}
                      </span>
                    </span>
                    <span className='navi-text font-size-lg'>Timesheet</span>
                  </NavLink>
                </div>
              </div>
              <div className='navi navi-bold navi-hover navi-active navi-link-rounded'>
                <div className='navi-item mb-2'>
                  <NavLink to={'/services/manage-job/documents/' + jobId} className='navi-link py-4' activeClassName='active'>
                    <span className='navi-icon mr-2'>
                      <span className='svg-icon'>
                        <SVG src={toAbsoluteUrl('/media/svg/icons/Files/Group-folders.svg')}></SVG>{' '}
                      </span>
                    </span>
                    <span className='navi-text font-size-lg'>Documents</span>
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  ...alert.actions,
  ...confirmModal.actions,
})(JobManageCard);
